import React from "react";

const WORDS = [
  "Consultancy",
  "Capacity Building",
  "Business Development",
  "IT Management",
  "Resourcing",
  "Outsourcing",
  "Security & Safety",
];

export const Marquee = () => (
  <section className="relative py-16 md:py-24 border-y border-brand-line overflow-hidden" data-testid="marquee-section" aria-hidden="true">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0">
          {WORDS.map((w, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span className="font-display text-6xl md:text-8xl lg:text-9xl font-light text-stroke px-8 md:px-12 whitespace-nowrap">
                {w}
              </span>
              <span className="w-3 h-3 rounded-full bg-brand shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);

export default Marquee;
